const ARABIC_INDIC_DIGITS = /[٠-٩]/g;
const EASTERN_ARABIC_DIGITS = /[۰-۹]/g;

export const toLatinDigits = (value) =>
  String(value ?? "")
    .replace(ARABIC_INDIC_DIGITS, (digit) => String(digit.charCodeAt(0) - 0x0660))
    .replace(EASTERN_ARABIC_DIGITS, (digit) => String(digit.charCodeAt(0) - 0x06f0));

export const formatDisplayNumber = (value) => {
  const amount = Number(value);

  if (!Number.isFinite(amount)) return toLatinDigits(value);

  return new Intl.NumberFormat("en-US", {
    useGrouping: false,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const getDisplayDateLocale = (language) =>
  String(language || "")
    .toLowerCase()
    .startsWith("ar")
    ? "ar-EG-u-nu-latn"
    : "en-US";
